import React, { memo } from "react";

import { transformDateToLocalDateString } from "helpers";
import { ShowcaseCard, ShowcaseNotice } from "ui/components/Showcase";
import {
  countTires,
  formatTireDimension,
  TIRE_SET_INTRO_SAMPLE,
} from "ui/modules/fleet/tires/pages/TireSetEditCard/components/TireSetIntro/consts";

import { getRelocateRoute } from "../consts";
import { TireSetRelocateSceneProps } from "../types";

/** Korak "Potvrda": sažetak premještaja, povijest lokacija seta i zapis promjene. */
const RelocateSummaryScene: React.FC<TireSetRelocateSceneProps> = (props) => {
  const { currentSet, formValues } = props;
  const { from, to } = getRelocateRoute(props);
  const code = currentSet.code || TIRE_SET_INTRO_SAMPLE.code;
  const dimension = formatTireDimension(currentSet.tires[0]) || TIRE_SET_INTRO_SAMPLE.dimension;
  const quantity = countTires(currentSet.tires) || TIRE_SET_INTRO_SAMPLE.quantity;
  const date = transformDateToLocalDateString(formValues.transferDate ?? new Date());

  const rows = [
    { label: "Dimenzija", value: dimension },
    { label: "Količina", value: `${quantity} kom` },
    { label: "Iz", value: from },
    { label: "U", value: to },
    { label: "Datum", value: date },
  ];

  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-[-1rem] w-[17rem] h-[18rem]" delay={0}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Premještaj seta</div>
          <div className="text-sm font-bold text-slate-800 truncate">{code}</div>
          <div className="mt-3 space-y-2">
            {rows.map((row) => (
              <div key={row.label} className="flex items-center justify-between gap-2 rounded-md bg-slate-50 px-3 py-2 text-[0.7rem]">
                <span className="text-slate-500 flex-shrink-0">{row.label}</span>
                <span className="font-semibold text-slate-800 truncate">{row.value}</span>
              </div>
            ))}
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Povijest seta</div>
          <div className="mt-3 space-y-2 text-[0.65rem]">
            <div className="flex items-center gap-2 text-slate-400">
              <span className="w-2 h-2 rounded-full bg-slate-300 flex-shrink-0" />
              <span className="truncate">{from}</span>
            </div>
            <div className="flex items-center gap-2 font-semibold text-slate-700">
              <span className="w-2 h-2 rounded-full bg-blue-600 flex-shrink-0" />
              <span className="truncate">{to}</span>
            </div>
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-0.5rem] w-[15rem]" delay={0.5}>
        <ShowcaseNotice
          title="Premještaj ostaje zapisan"
          subtitle="Vidi se u povijesti seta"
          iconClassName="bg-blue-100"
          icon={
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#1D4ED8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <circle cx="12" cy="12" r="9" />
              <path d="M12 7v5l3 3" />
            </svg>
          }
        />
      </ShowcaseCard>
    </>
  );
};

export default memo(RelocateSummaryScene);
